import { repository } from '@woc/woc-repository'
import { CategoryPerformance } from '@/model/report'

export const companyPerformanceRepository = repository.create({
  entity: 'companyPerformance',
  url: 'companies/:companyId/sales-performance',
  allow: 'l',
  factory: data => new CategoryPerformance(data)
})

export default repository.asModule(companyPerformanceRepository)
